import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';
import { HttpModule } from '@angular/http';
import { environment } from '../../environments/environment';
import { User } from '../layout/form/user';
import { Login } from '../layout/form/login';
import { Card } from '../layout/credit-card/card';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class UserService {

  private message = 'v!neyardc@kes';
  restApiURL = environment.restApiURL;
  constructor(public http: Http) { }

  createUsers(user: User) {
    return this.http.post(this.restApiURL + '/glam.php?action=insert_users', user)
      .map(res => res.json());
  }
  verifyUser(login: Login) {
    return this.http.post(this.restApiURL + '/glam.php?action=verify_user', login)
      .map(res => res.json());
  }
  insertOrder(cardInfo: Card) {
    console.log(cardInfo);
    return this.http.post(this.restApiURL + '/glam.php?action=insertOrder', cardInfo)
      .map(res => res.json());
  }
  listState() {
    return this.http.post(this.restApiURL + '/glam.php?action=listState', this.message)
    .map(res => res.json());
  }
  listCity(stateId) {
    return this.http.post(this.restApiURL + '/glam.php?action=listCity&stateId='+stateId,this.message)
    .map(res => res.json());
  }
  verifySubscribeUser(id) {

    return this.http.post(this.restApiURL + '/glam.php?action=verifySubscribeUser&id='+id,this.message)
    .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/user.service.ts